import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-angle-double-up-icon',
  templateUrl: './navigation-angle-double-up.component.html'
})
export class NavigationAngleDoubleUpComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
